import { render } from "./client-import-dialog.vue?vue&type=template&id=062a3cea&scoped=true"
import script from "./client-import-dialog.vue?vue&type=script&lang=js"
export * from "./client-import-dialog.vue?vue&type=script&lang=js"

import "./client-import-dialog.vue?vue&type=style&index=0&id=062a3cea&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062a3cea"]])

export default __exports__